"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WITHDRAWAL_CONFIRM = void 0;
var WITHDRAWAL_CONFIRM = 'WITHDRAWAL_CONFIRM';
exports.WITHDRAWAL_CONFIRM = WITHDRAWAL_CONFIRM;